import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

class SingleElement extends React.Component {
    shouldComponentUpdate(nextProps) {
        if (nextProps.option.label !== this.props.option.label) {
            return true;
        } else if (nextProps.option.value !== this.props.option.value) {
            return true;
        }
        return false;
    }

    render() {
        return this.props.option.label;
    }
}

const SearchSelect = ({
                          options,
                          isLoading,
                          isClearable,
                          isSearchable,
                          value,
                          onChange,
                          onBlur,
                          isMulti,
                          isDisabled = false,
                          className = "",
                          width = "100%",
                          placeholder = "Select...",
                          defaultValue = null
                      }) => (
    <Select
        className={className}
        classNamePrefix={className}
        options={options}
        isLoading={isLoading}
        isClearable={isClearable}
        isSearchable={isSearchable}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        isMulti={isMulti}
        optionComponent={SingleElement}
        styles={{
            input: base => ({ ...base, autoComplete: "off" }),
            menu: base => ({ ...base, zIndex: 100 })
        }}
        isDisabled={isDisabled}
        width={width}
        placeholder={placeholder}
        defaultValue={defaultValue}
    />
);

SearchSelect.propTypes = {
    options: PropTypes.array,
    isLoading: PropTypes.bool.isRequired,
    isClearable: PropTypes.bool,
    isSearchable: PropTypes.bool,
    isMulti: PropTypes.bool,
    onChange: PropTypes.func.isRequired
};

SearchSelect.defaultProps = {
    isClearable: true,
    isSearchable: true
};

export default SearchSelect;
